import { render, staticRenderFns } from "./BankForm.vue?vue&type=template&id=56b27cae&scoped=true&"
import script from "./BankForm.vue?vue&type=script&lang=js&"
export * from "./BankForm.vue?vue&type=script&lang=js&"
import style0 from "./BankForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BankForm.vue?vue&type=style&index=1&id=56b27cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b27cae",
  null
  
)

export default component.exports